import Helper from "./Helper";
import * as S from "./../Vars/shares";
import SharesShared from "./SharesShared";

/**
 * Shares Drop Down Handler
 * ------------------------
 * - handles the Dropdown Data
 * - builds the Selects
 * - registers Checkbox clicks
 */
class SharesDropDown {
  constructor() {}

  dropParser(data, dropdownIndex) {
    const ColIndexes = [];
    let toggleName = null;
    let dropNames = [];
    let dropIDs = [];
    data.forEach((row, index) => {
      if (index == 0) {
        // keys row
        row.forEach((col, index) => {
          // find indexes for current language values
          let c = col.split(" ");
          if (c.length > 1) {
            if (c[1].toLowerCase() == S.lang.toLowerCase()) {
              ColIndexes.push(index);
            }
          } else {
            ColIndexes.push(index);
          }
        });
      } else {
        // value rows
        row.forEach((col, index) => {
          // grab toggle Name (first colindex value)
          if (index == ColIndexes[0]) {
            if (col != "") {
              toggleName = col;
            }
          }
          if (index == ColIndexes[1]) {
            dropIDs.push(col);
          }
          if (index == ColIndexes[2]) {
            dropNames.push(col);
          }
        });
      }
    });
    this.buildDropdown(toggleName, dropIDs, dropNames, dropdownIndex);
  }

  buildDropdown(toggleName, dropIDs, dropNames, dropdownIndex) {
    const select = document.createElement("div");
    const dropName = `drop-${dropdownIndex}`;
    Helper.addClass(select, "ns-select-dropdown");
    let html = `<div class="ns-select-dropdown__toggle js-select-toggle">
                  <span>${toggleName}</span>
                </div>
                <div class="ns-select-dropdown__dropdown">`;
    dropNames.forEach((drop, index) => {
      const unique = dropName + "-" + dropIDs[index];
      html += `<div class="ns-select-dropdown__option">
                  <input id="${unique}" name="${dropName}" class="shares-dropdown" type="checkbox" checked value="${unique}">
                  <label for="${unique}">${drop}</label>
                </div>`;
    });
    html += `</div>`;
    select.innerHTML = html;
    S.dropDownContainer.append(select);

    this.registerDropClick(select);
    this.registerDropFilter();
  }

  registerDropClick(select) {
    const toggle = select.querySelector(".js-select-toggle");
    toggle.addEventListener("click", (e) => {
      if (toggle.classList.contains("active")) {
        Helper.slideClose(toggle.nextElementSibling);
        toggle.classList.remove("active");
      } else {
        Helper.slideOpen(toggle.nextElementSibling, true);
        toggle.classList.add("active");
      }
    });
  }

  registerDropFilter() {
    const inputs = [...document.querySelectorAll(`input[name^="drop-"]`)];
    this.handleDropDisplay(inputs);
    inputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        this.handleDropDisplay(inputs);
      });
    });
  }

  handleDropDisplay(inputs) {
    inputs.forEach((input) => {
      const dropTotal = S.dropDowns.length;
      if(S.tiles.length > 0){
        S.tiles.forEach((tile) => {
          let visible = true;
          for (let drop = 0; drop < dropTotal; drop++) {
            const val = tile.getAttribute("data-drop-" + drop);
            const checkbox = document.querySelector(`input[value="drop-${drop}-${val}"]`);
            if(checkbox){
              if (!checkbox.checked) {
                visible = false;
              }
            }
          }
          if (visible) {
            Helper.addClass(tile, "visible");
          } else {
            Helper.removeClass(tile, "visible");
          }
        });
      }
    });
  }
}

export default SharesDropDown;
